<script setup>
import { useAppStore } from '@/stores/App'

// Vars
const app = useAppStore()

// SEO
useSeoMeta({
    title: 'FAQs',
    ogTitle: 'FAQs',
    description: 'satYatunes FAQs',
    ogDescription: 'satYatunes FAQs',
})
</script>

<template>
    <v-row id="faqs" justify="center" align="start" class="slide-from-top">
        <v-col cols="12" sm="10" class="mt-4 text-center">
            <app-section-header :id="`support`" :title="`Frequently Asked Questions`" :subtitle="``" />
            <div class="my-4">
                If you don't find any answer to your question, then please
                <nuxt-link :to="`/support`" aria-label="satYatunes support center">contact</nuxt-link> us.
            </div>
        </v-col>
        <v-col cols="12" sm="10" class="mb-16">
            <v-expansion-panels class="mb-10 elevation-0">
                <v-expansion-panel v-for="(item, i) in app.faqs" :key="i" class="elevation-0">
                    <v-expansion-panel-title class="text-h6">
                        {{ item.title }}
                    </v-expansion-panel-title>
                    <v-expansion-panel-text class="st-text-normal">
                        <div v-html="item.content"></div>
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-col>
    </v-row>
</template>

<style scoped></style>
